import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterApply = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M9.713 16.262L6 17.5V9L1.52 4.072C1.18545 3.70393 1.00005 3.2244 1 2.727V0.5H17V2.672C16.9999 3.20239 16.7891 3.71101 16.414 4.086L12 8.5V9.5M20.25 13.2309L15 16.262V10.1998L20.25 13.2309Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgFilterApply);
export { ForwardRef as ReactComponent };
